import { useState } from 'react';
import { useCreateResource, useUpdateResource, useSelectedPlant } from '../../../../hooks';

import { SetupDrawer } from '../../../atoms';
import { TextInput } from '@pella/sash-framework';

/**
 * Component for the Resource Drawer.
 * @param {Local.SetupDrawerProps} props - Component props
 */
export const ResourceDrawer = ({ open, close, data, selectedId }) => {
  const { selectedPlant } = useSelectedPlant();
  const { mutate: createResource, isPending: isCreating } = useCreateResource();
  const { mutate: updateResource, isPending: isUpdating } = useUpdateResource();

  const [formChanges, setFormChanges] = useState(
    /** @type {Partial<Pella.ProductionRequestAPI.CreateResourceInput>} */ ({}),
  );

  const currentForm = selectedId ? data?.find((record) => record.id === selectedId) : { active: true };

  // Combine initial data with form changes to get the current resource state
  const resource = { ...currentForm, ...formChanges };
  const isEdit = Boolean(selectedId);

  /** Handler to reset form and close drawer */
  const handleClose = () => {
    setFormChanges({});
    close();
  };

  /** handler for form submission */
  const handleSubmit = () => {
    // Ensure all required fields are defined before mutation
    if (!isEdit) {
      const input = {
        plantId: selectedPlant,
        /* v8 ignore start */
        active: resource.active ?? true,
        description: resource.description || '',
        /* v8 ignore stop */
      };
      createResource(input, { onSuccess: handleClose });
    } else {
      const id = selectedId;
      const input = {
        description: resource.description,
        active: resource.active,
      };
      updateResource({ id, input }, { onSuccess: handleClose });
    }
  };

  const hasRequiredFields = Boolean(resource.description?.trim());
  const isLoading = isCreating || isUpdating;

  const disableSubmit = !hasRequiredFields || isLoading;
  const disableForms = !resource.active;
  return (
    <SetupDrawer
      open={open}
      close={handleClose}
      title='Resource'
      isEdit={isEdit}
      isCopy={false}
      active={Boolean(resource.active)}
      onActiveChange={() => setFormChanges((prev) => ({ ...prev, active: !resource.active }))}
      onSubmit={handleSubmit}
      disableSubmit={disableSubmit}
    >
      <TextInput
        id='resourceNameInput'
        labelText='Resource Name'
        disabled={disableForms}
        maxLength={50}
        required={Boolean(!resource.description)}
        value={resource.description || ''}
        onChange={(e) => setFormChanges((prev) => ({ ...prev, description: e.target.value }))}
      />
    </SetupDrawer>
  );
};
